const features = [
  {
    icon: 'ri-4k-line',
    title: '高清片源 · 画质出众',
    desc: '所有影片基于高清甚至蓝光片源压制，画质清晰锐利。无论是大屏幕投屏还是手机观看，555影视都确保最佳观影画质，让每一帧画面都纤毫毕现。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅播放 · 无需缓冲',
    desc: '采用先进的CDN加速与视频分发技术，多线服务器智能调度。即使在网络高峰期，也能保持流畅不缓冲的播放体验，让您告别卡顿等待的烦恼。',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量片库 · 每日更新',
    desc: '20000+部高清电影资源覆盖全类型，从最新上映的热门大片到经典老片应有尽有。555影视团队每日更新片库，确保您总能找到想看的好电影。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-900 mb-3">
            平台特色
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            为什么越来越多的影迷选择555影视在线看电影
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((item, i) => (
            <div
              key={i}
              className="group text-center p-8 rounded-2xl bg-background-100 border border-background-200/70 cursor-pointer transition-all duration-300 hover:border-primary-200"
            >
              <div className="inline-flex w-16 h-16 items-center justify-center rounded-2xl bg-primary-50 mb-5 group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-primary-600 text-2xl`}></i>
              </div>
              <h3 className="text-base font-heading text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}